jQuery(document).ready(function($) {
    ExportUsers = new function()
    {
        this.init = function() {
            jQuery('form.export-users').submit(function(event) {
                event.preventDefault();

                var href          = jQuery(this).attr('action');
                var table_type    = jQuery(this).data('table-type');
                var table         = jQuery('table[data-table-type="'+table_type+'"]').DataTable();
                var filtered_data = table.rows({search:'applied'}).nodes();
                var users         = [];

                jQuery(filtered_data).each(function(index, el) {
                    users.push(jQuery(el).data('user-id'));
                });

                var user_ids         = users.join();
                window.location.href = href + '?users=' + user_ids;
            });
        };
    }

    ExportUsers.init();
});
